import React from "react";
import { useTranslation } from "next-i18next";

export default function BlogTags({
	tag,
	isIncludes,
	key,
	filters,
	setFilters
}) {
	const { t } = useTranslation();
	return (
		<div className={isIncludes ? "blog_tags_active" : "blog_tags"}
			onClick={() => {
				const name = tag;
				const isIncludes = filters.some((f) =>
					f.name.includes(name)
				);
				if (!isIncludes)
					setFilters((prevValue) => [
						...prevValue,
						{ name, isActive: true },
					]);

				if (isIncludes) {
					setFilters(filters.filter((f) => f.name !== name));
				}
			}}
		>
			<p>{tag}</p>
		</div>
	);
}
